<div class="commentItem" [id]="'comment-' + comment.id">
	<div class="commentTitle">
		{{comment.user}} on {{comment.date | date:'shortDate'}} at {{comment.date | date:'shortTime'}}
		<div class="right"><a href="#{{comment.id}}" data-toggle="collapse" [attr.aria-controls]="comment.id" aria-expanded="false"><em class="fas fa-reply" title="Reply"></em></a></div>
	</div>
	<div class="comment">{{comment.comment}}</div>
	<div class="commentResponse" [id]="comment.id">
		<ng-container *ngIf="!authService.isAuthenticated()">
			<input type="text" name="commentUser" [(ngModel)]="newUserComment.user" placeholder="Name" class="form-control">
			<input type="text" name="commentEmail" [(ngModel)]="newUserComment.email" placeholder="E-mail (optional)" class="form-control">
		</ng-container>
		<textarea name="comment" [(ngModel)]="newUserComment.comment" placeholder="Enter a comment..." class="form-control"></textarea>
		<a href="#{{comment.id}}" data-toggle="collapse" (click)="clearCommentForm()"><button type="reset">Cancel</button></a>
		<a><button type="button" (click)="onCommentSubmit()" [disabled]="!newUserComment.user || !newUserComment.comment">Reply</button></a>
	</div>
	<div class="childComment" *ngFor="let subComment of comment.childComments">
		<app-comments (newComment)="onNewComment($event)" [comment]="subComment" [item]="item"></app-comments>
	</div>
</div>